import carpet2 from "../assets/carpet_2.jpg";
import carpet3 from "../assets/carpet_3.jpg";
import carpet4 from "../assets/carpet_4.jpg";

export default function About() {
  const carpets = [carpet2, carpet3, carpet4];

  return (
    <div className="bg-[#F7F1E8] text-[#3B2A1F]">
      {/* =====================================================
          HERO
      ===================================================== */}
      <section className="relative flex min-h-[680px] items-center overflow-hidden sm:min-h-[750px]">
        <img
          src={carpet2}
          alt="Traditional handmade Afghan rug"
          className="absolute inset-0 h-full w-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20" />

        <div className="relative z-10 mx-auto w-full max-w-7xl px-6 py-24 sm:px-8 lg:px-12">
          <div className="max-w-4xl text-white">
            <div className="mb-7 flex items-center gap-4">
              <div className="h-px w-12 bg-[#C9A66B]" />
              <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#F7F1E8] sm:text-sm">
                A1 Rugs
              </p>
            </div>

            <h1 className="font-serif text-5xl font-medium leading-[1.08] sm:text-6xl md:text-7xl lg:text-8xl">
              A Tradition
              <br />
              Woven Through
              <br />
              Generations.
            </h1>

            <p className="mt-8 max-w-2xl text-base leading-8 text-white/85 sm:text-lg md:text-xl">
              From a family tradition that began approximately 150 years ago
              to A1 Rugs today, our story is rooted in handmade rugs,
              craftsmanship, and generations of experience.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                type="button"
                onClick={() => {
                  window.location.href = "/products/All";
                }}
                className="rounded-full bg-[#C9A66B] px-7 py-3.5 text-sm font-semibold text-[#2F241B] transition duration-300 hover:bg-[#E0C28D] hover:shadow-2xl"
              >
                Explore Our Collection
              </button>

              <div className="flex items-center gap-3 rounded-full border border-white/25 bg-white/10 px-5 py-3 backdrop-blur-md">
                <span className="text-2xl font-semibold text-[#F7F1E8]">
                  150+
                </span>
                <span className="text-xs uppercase tracking-wider text-white/75">
                  Years of Tradition
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#F7F1E8] to-transparent" />
      </section>

      {/* =====================================================
          INTRO
      ===================================================== */}
      <section className="mx-auto max-w-7xl px-6 py-20 sm:px-8 sm:py-24 lg:px-12 lg:py-28">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:items-end lg:gap-20">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#0F5C5E]">
              Our Story
            </p>

            <h2 className="mt-4 max-w-xl font-serif text-4xl font-medium leading-tight text-[#0F5C5E] sm:text-5xl lg:text-6xl">
              More Than a Rug.
              <br />
              A Family Tradition.
            </h2>
          </div>

          <div className="max-w-2xl">
            <p className="text-lg leading-9 text-[#5A4A3A] sm:text-xl">
              At A1 Rugs, our connection to handmade rugs began approximately
              150 years ago. What started as traditional rug trading grew into
              a family profession built on knowledge, experience, and a deep
              connection to the craft.
            </p>
          </div>
        </div>
      </section>

      {/* =====================================================
          HERITAGE
      ===================================================== */}
      <section className="mx-auto max-w-7xl px-6 pb-20 sm:px-8 sm:pb-28 lg:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          {/* Image */}
          <div className="relative">
            <div className="overflow-hidden rounded-[2rem] shadow-2xl">
              <img
                src={carpet3}
                alt="Handmade Afghan rug"
                className="h-[500px] w-full object-cover transition duration-700 hover:scale-105 sm:h-[600px]"
              />
            </div>

            <div className="absolute -bottom-6 left-5 rounded-2xl bg-[#0F5C5E] px-6 py-5 text-white shadow-2xl sm:left-8 sm:px-8 sm:py-6">
              <p className="text-3xl font-semibold">150+</p>
              <p className="mt-1 text-xs uppercase tracking-[0.18em] text-white/75">
                Years of Family Tradition
              </p>
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#0F5C5E]">
              Our Heritage
            </p>

            <h2 className="mt-4 font-serif text-4xl font-medium leading-tight text-[#0F5C5E] sm:text-5xl">
              A Journey Through Generations
            </h2>

            <div className="mt-6 h-px w-16 bg-[#C9A66B]" />

            <p className="mt-8 text-lg leading-9 text-[#5A4A3A]">
              Our ancestors lived in Turkmenistan, where they traded rugs with
              food and other goods and traveled to Afghanistan as part of their
              trade.
            </p>

            <p className="mt-6 text-lg leading-9 text-[#5A4A3A]">
              As the value and appreciation of handmade rugs grew, our family
              became increasingly focused on the rug business. Across
              generations, we continued buying, trading, and selling handmade
              rugs while carrying forward the knowledge of those who came
              before us.
            </p>

            <p className="mt-6 text-lg leading-9 text-[#5A4A3A]">
              Our family also continued its rug business in Pakistan for around
              40 years. After returning to Afghanistan, we continued the same
              profession and kept our connection to handmade rug trading alive.
            </p>
          </div>
        </div>
      </section>

      {/* =====================================================
          HERITAGE TIMELINE
      ===================================================== */}
      <section className="border-y border-[#DCCFBE] bg-[#EFE7DA]">
        <div className="mx-auto max-w-7xl px-6 py-20 sm:px-8 sm:py-24 lg:px-12">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#0F5C5E]">
              The Journey
            </p>

            <h2 className="mt-4 font-serif text-4xl font-medium text-[#0F5C5E] sm:text-5xl">
              From Tradition to A1 Rugs
            </h2>

            <div className="mx-auto mt-6 h-px w-16 bg-[#C9A66B]" />
          </div>

          <div className="relative mt-16 grid gap-10 md:grid-cols-4 md:gap-6">
            <div className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px bg-[#C9A66B] md:block" />

            <div className="relative text-center">
              <div className="relative mx-auto flex h-12 w-12 items-center justify-center rounded-full border-4 border-[#EFE7DA] bg-[#0F5C5E] text-sm font-semibold text-white shadow-lg">
                01
              </div>

              <h3 className="mt-6 font-serif text-2xl text-[#0F5C5E]">
                Turkmenistan
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#5A4A3A]">
                Our family began trading rugs and goods through traditional
                routes.
              </p>
            </div>

            <div className="relative text-center">
              <div className="relative mx-auto flex h-12 w-12 items-center justify-center rounded-full border-4 border-[#EFE7DA] bg-[#C9A66B] text-sm font-semibold text-white shadow-lg">
                02
              </div>

              <h3 className="mt-6 font-serif text-2xl text-[#0F5C5E]">
                Afghanistan
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#5A4A3A]">
                Our family's connection to handmade rugs continued and became a
                lasting profession.
              </p>
            </div>

            <div className="relative text-center">
              <div className="relative mx-auto flex h-12 w-12 items-center justify-center rounded-full border-4 border-[#EFE7DA] bg-[#0F5C5E] text-sm font-semibold text-white shadow-lg">
                03
              </div>

              <h3 className="mt-6 font-serif text-2xl text-[#0F5C5E]">
                Pakistan
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#5A4A3A]">
                The family rug business continued in Pakistan for around 40
                years.
              </p>
            </div>

            <div className="relative text-center">
              <div className="relative mx-auto flex h-12 w-12 items-center justify-center rounded-full border-4 border-[#EFE7DA] bg-[#C9A66B] text-sm font-semibold text-white shadow-lg">
                04
              </div>

              <h3 className="mt-6 font-serif text-2xl text-[#0F5C5E]">
                A1 Rugs
              </h3>

              <p className="mt-3 text-sm leading-7 text-[#5A4A3A]">
                Today, that family tradition continues through A1 Rugs,
                serving customers around the world.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          A1 RUGS TODAY
      ===================================================== */}
      <section className="bg-[#0F5C5E]">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
          <div className="grid items-center lg:grid-cols-2">
            {/* Image */}
            <div className="relative py-16 sm:py-20 lg:py-24 lg:pr-12">
              <div className="overflow-hidden rounded-[2rem] shadow-2xl">
                <img
                  src={carpet2}
                  alt="Traditional handmade rug"
                  className="h-[500px] w-full object-cover transition duration-700 hover:scale-105 sm:h-[620px]"
                />
              </div>
            </div>

            {/* Content */}
            <div className="py-16 sm:py-20 lg:py-24 lg:pl-12">
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C9A66B]">
                A1 Rugs Today
              </p>

              <h2 className="mt-4 font-serif text-4xl font-medium leading-tight text-[#F7F1E8] sm:text-5xl">
                From Our Family
                <br />
                to Your Home
              </h2>

              <div className="mt-6 h-px w-16 bg-[#C9A66B]" />

              <p className="mt-8 text-lg leading-9 text-white/80">
                Today, our business is registered in the United States under
                the name <strong className="text-white">A1 Rugs</strong>. Our
                team and rug operations are based in Afghanistan, keeping us
                close to the handmade rugs, artisans, and traditions that have
                been part of our family's life for generations.
              </p>

              <p className="mt-6 text-lg leading-9 text-white/80">
                A1 Rugs is the continuation of what our ancestors started. What
                began as traditional rug trading between Turkmenistan and
                Afghanistan has grown into a family business serving customers
                around the world.
              </p>

              <div className="mt-10 grid grid-cols-2 gap-6 border-t border-white/15 pt-8">
                <div>
                  <p className="text-3xl font-semibold text-[#F7F1E8]">
                    150+
                  </p>
                  <p className="mt-2 text-xs uppercase tracking-[0.18em] text-white/60">
                    Years of Tradition
                  </p>
                </div>

                <div>
                  <p className="text-3xl font-semibold text-[#F7F1E8]">
                    Worldwide
                  </p>
                  <p className="mt-2 text-xs uppercase tracking-[0.18em] text-white/60">
                    Customers Served
                  </p>
                </div>
              </div>

              <p className="mt-8 text-base leading-8 text-white/70">
                We are proud to share handmade rugs with people everywhere
                while keeping our family tradition alive. We also offer{" "}
                <strong className="text-white">free worldwide shipping</strong>
                , making it easier to bring a piece of this heritage into your
                home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          VALUES
      ===================================================== */}
      <section className="mx-auto max-w-7xl px-6 py-20 sm:px-8 sm:py-24 lg:px-12 lg:py-28">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#0F5C5E]">
            What We Stand For
          </p>

          <h2 className="mt-4 font-serif text-4xl font-medium text-[#0F5C5E] sm:text-5xl">
            The A1 Rugs Difference
          </h2>

          <div className="mx-auto mt-6 h-px w-16 bg-[#C9A66B]" />

          <p className="mt-6 text-lg leading-8 text-[#5A4A3A]">
            Our approach is built around the values that have stayed with our
            family throughout generations.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[
            {
              number: "01",
              title: "Heritage",
              text: "A family connection to handmade rug trading spanning approximately 150 years.",
            },
            {
              number: "02",
              title: "Craftsmanship",
              text: "A close connection to Afghanistan's handmade rug tradition and its artisans.",
            },
            {
              number: "03",
              title: "Authenticity",
              text: "Rugs selected with an appreciation for their character, design, and handmade nature.",
            },
            {
              number: "04",
              title: "Service",
              text: "A straightforward shopping experience designed to connect our rugs with homes worldwide.",
            },
          ].map((item) => (
            <div
              key={item.number}
              className="group rounded-[1.75rem] border border-[#E3D9CA] bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl sm:p-8"
            >
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold tracking-[0.2em] text-[#C9A66B]">
                  {item.number}
                </span>

                <span className="h-px w-10 bg-[#DCCFBE] transition-all duration-300 group-hover:w-16 group-hover:bg-[#C9A66B]" />
              </div>

              <h3 className="mt-8 font-serif text-2xl text-[#0F5C5E]">
                {item.title}
              </h3>

              <p className="mt-4 text-sm leading-7 text-[#6B5B4B]">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* =====================================================
          COLLECTION
      ===================================================== */}
      <section className="bg-[#EFE7DA] py-20 sm:py-24 md:py-28">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
          <div className="mb-14 flex flex-col gap-6 md:mb-16 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#0F5C5E]">
                A Glimpse Into Our Work
              </p>

              <h2 className="mt-4 font-serif text-4xl font-medium text-[#0F5C5E] sm:text-5xl">
                Handmade Rugs
              </h2>
            </div>

            <p className="max-w-xl text-base leading-8 text-[#5A4A3A] md:text-right">
              Every handmade rug carries the character of the artisan who
              created it and the traditions passed down through generations.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            {carpets.map((carpet, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-[1.75rem] bg-white shadow-xl"
              >
                <img
                  src={carpet}
                  alt={`Handmade Afghan rug ${index + 1}`}
                  className="h-[430px] w-full object-cover transition duration-700 group-hover:scale-105 sm:h-[500px]"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent opacity-0 transition duration-300 group-hover:opacity-100" />

                <div className="absolute bottom-5 left-5 rounded-full bg-white/90 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#0F5C5E] opacity-0 backdrop-blur-md transition duration-300 group-hover:opacity-100">
                  A1 Rugs
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          CTA
      ===================================================== */}
      <section className="relative overflow-hidden bg-[#083F40] py-24 text-white sm:py-28 md:py-32">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#0F5C5E] opacity-40 blur-3xl" />
        <div className="absolute -bottom-32 -right-20 h-80 w-80 rounded-full bg-[#C9A66B] opacity-10 blur-3xl" />

        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C9A66B]">
            Discover A1 Rugs
          </p>

          <h2 className="mt-5 font-serif text-4xl font-medium leading-tight text-[#F7F1E8] sm:text-5xl md:text-6xl">
            Bring a Piece of Our
            <br className="hidden sm:block" />
            Tradition Home.
          </h2>

          <p className="mx-auto mt-7 max-w-2xl text-lg leading-8 text-white/70">
            Explore our collection of handmade rugs and discover pieces shaped
            by generations of tradition and craftsmanship.
          </p>

          <button
            type="button"
            onClick={() => {
              window.location.href = "/products/All";
            }}
            className="mt-10 rounded-full bg-[#C9A66B] px-8 py-4 text-sm font-semibold text-[#2F241B] shadow-lg transition duration-300 hover:-translate-y-1 hover:bg-[#E0C28D] hover:shadow-2xl sm:px-10"
          >
            Explore Collection
          </button>
        </div>
      </section>
    </div>
  );
}